import { ChatterPost } from './types';

// Demo data until posts are persisted.
export const CHATTER_ACCOUNT_SEED_POSTS: Array<ChatterPost> = [
  {
    id: 'seed-account-welcome',
    authorName: 'Alexis Cunningham',
    audience: 'The LuxGroup Only',
    createdAt: '2026-09-09T11:05:00',
    text: 'Gold Experience is Closed Won. Account weighting stays at 1, flag if anyone needs a partner-engagement review before the Oct run.',
    likeCount: 2,
    isLikedByMe: false,
    comments: [
      {
        id: 'seed-account-comment',
        authorName: 'Catherine Geard',
        createdAt: '2026-09-09T13:22:00',
        text: "Noted, I'll keep Flash engage status as Engage Partner.",
      },
    ],
  },
  {
    id: 'seed-account-bank',
    authorName: 'System',
    audience: 'The LuxGroup Only',
    createdAt: '2026-02-03T14:56:00',
    text: 'AUS Bank Account Name was updated from Fairmont Century Plaza LLC to Fairmont Century Plaza.',
    likeCount: 0,
    isLikedByMe: false,
    comments: [],
  },
];
